import { ReactElement } from 'react';
import { Table, TableProps } from '@ohpen/enso-ui';

import { ActionEntityType } from '@pmp/api';
import { AssistantRow } from '../brokerCRConfig';

type AssistantsCRProps = { tableProps: TableProps<ActionEntityType, AssistantRow> };

export const AssistantsCR = ({ tableProps }: AssistantsCRProps): ReactElement => {
  return <Table {...tableProps} />;
};
